import React from "react";
import { useQuery } from "@tanstack/react-query";
import { adminApi } from "@/admin/api";

const ACTION_TONE = {
  "admin.login": "text-totem-green",
  "user.block": "text-totem-red",
  "user.unblock": "text-totem-green",
  "feature_flag.update": "text-totem-gold",
  "set_piece.create": "text-totem-green",
  "set_piece.delete": "text-totem-red",
  "set_piece.update": "text-totem-gold",
  "lineup.create": "text-totem-green",
  "lineup.delete": "text-totem-red",
  "lineup.update": "text-totem-gold",
};

export default function AdminAudit() {
  const { data, isLoading } = useQuery({
    queryKey: ["admin-audit"],
    queryFn: async () => (await adminApi.get("/audit-log", { params: { limit: 200 } })).data,
    staleTime: 15_000,
    refetchInterval: 30_000,
  });
  const rows = data?.results || [];
  return (
    <div className="space-y-4 animate-fade-up">
      <div>
        <div className="mono uppercase text-[11px] tracking-widest text-totem-textDim">Admin</div>
        <h1 className="display-heading text-3xl">Audit log</h1>
      </div>
      <div className="totem-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-totem-surface">
            <tr>
              <th className="text-left px-3 py-2 label-caps">When</th>
              <th className="text-left px-3 py-2 label-caps">Admin</th>
              <th className="text-left px-3 py-2 label-caps">Action</th>
              <th className="text-left px-3 py-2 label-caps">Target</th>
              <th className="text-left px-3 py-2 label-caps">Details</th>
            </tr>
          </thead>
          <tbody>
            {isLoading && (
              <tr><td colSpan={5} className="p-4 text-center text-totem-textDim animate-pulse">Loading…</td></tr>
            )}
            {!isLoading && rows.length === 0 && (
              <tr><td colSpan={5} className="p-4 text-center text-totem-textDim">No admin activity yet.</td></tr>
            )}
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-totem-borderSoft">
                <td className="px-3 py-2 mono text-[11px] text-totem-textDim">
                  {new Date(r.created_at).toLocaleString()}
                </td>
                <td className="px-3 py-2 text-xs truncate max-w-[180px]">{r.admin_email}</td>
                <td className={`px-3 py-2 mono text-xs uppercase font-semibold ${ACTION_TONE[r.action_type] || "text-totem-text"}`}>
                  {r.action_type}
                </td>
                <td className="px-3 py-2 mono text-[11px] text-totem-textDim">
                  {r.target_type && `${r.target_type} `}
                  {r.target_id && <span className="text-totem-textFaint">#{String(r.target_id).slice(0, 8)}</span>}
                </td>
                <td className="px-3 py-2 mono text-[10px] text-totem-textFaint truncate max-w-[280px]">
                  {r.details && Object.keys(r.details).length > 0 ? JSON.stringify(r.details) : "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
